var DATE_FULL_MASK_REGEX = /\s\/\s/;
var DATE_MASK_CHARS_REGEX = /[ /]/;
var DATE_MASK_USER_INPUT_REGEX = /^\d{2}[ /]{1,4}\d{0,2}$/;
var SANITIZE_DATE_REGEX = /(^\D+)|[^\d /]/g;
var PROPS_TO_FILTER = ['cardDateType', 'changeHandler', 'inputStyleOverrides', 'maxLength', 'pattern', 'type'];
export { DATE_FULL_MASK_REGEX, DATE_MASK_CHARS_REGEX, DATE_MASK_USER_INPUT_REGEX, PROPS_TO_FILTER, SANITIZE_DATE_REGEX };